const { Joi, options, fieldOptions, labels, errors } = require("./joi");
const constants = require("./constants");
const models = require("./models");
const fields = require("./shared");
const { setLabels } = require("./utils");

module.exports = (function() {
  setLabels(labels);

  const joiValidator = {
    Joi,
    labels,
    options,
    errors,
    fieldOptions,
    ...models,
    ...constants,
    CommonValidators: {
      ...fields,
      ...constants.REGEX,
    },

    model(name) {
      if (models.hasOwnProperty(name)) {
        return models[name];
      }
      throw new Error(
        `There is no ${name} model registered. Listed models are: ${Object.keys(
          models
        )}`
      );
    },

    schema(name, options = {}) {
      return this.model(name)(options.prefix, { ...this._options, ...options });
    },

    validate(name, value, options) {
      return this.schema(name).validate(value, options);
    },
  };

  return joiValidator;
})();
